export const dop_annual_report = [
  {
    id: 1,
    name: 'department-of-the-premier-strategic-plan-2025-2030',
    summary: 'shortsummary/department-of-the-premier-strategic-plan-2025-2030.html',
    link: 'department-of-the-premier-strategic-plan-2025-2030.pdf',
    audio_en: 'audio/en/department-of-the-premier-strategic-plan-2025-2030_en.mp3',
    audio_af: 'audio/af/department-of-the-premier-strategic-plan-2025-2030_af.mp3',
    audio_xh: 'audio/xh/department-of-the-premier-strategic-plan-2025-2030_xh.mp3'
  }
];